import { render, staticRenderFns } from "./AddProductAttributesAttributesStep.vue?vue&type=template&id=27f1ac95&scoped=true"
import script from "./AddProductAttributesAttributesStep.ts?vue&type=script&lang=ts&external"
export * from "./AddProductAttributesAttributesStep.ts?vue&type=script&lang=ts&external"
import style0 from "./AddProductAttributesAttributesStep.scss?vue&type=style&index=0&id=27f1ac95&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1ac95",
  null
  
)

export default component.exports